module.exports = __webpack_public_path__ + "static/media/ChevronDown.a073e7f2.svg";